import { combineReducers } from 'redux';

export const SET_AuthCustomer = 'SET_AuthCustomer';
export interface CustomerTokenInfo {
    customerId?: number;
    mobile?: string,
    fullName?: string;
    token?:string
}
export const ActionAuthCustomer = {
    SetAuth(data: CustomerTokenInfo|null) {
        return { type: SET_AuthCustomer, data: data };
    }
}
const CustomerAuth = (state =null, action: any) => {

    switch (action.type) {
        case SET_AuthCustomer:
            state = action.data;
            return state
        default:
            return state
    }
}
export const getCustomerAuth = (state: any) => state.CustomerAuth;
export default combineReducers({
    CustomerAuth
});
